<template>
  <VanDialog
    :value="show"
    :show-confirm-button="false"
    :show-cancel-button="false"
    :getContainer="getContainer"
    close-on-click-overlay
    @click-overlay="onClose"
    @close="onClose"
  >
    <div class="hub-order-cancel">
      <div class="title">{{ title }}</div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="footer">
        <div @click="onConfirm" class="btn">确定（{{ count }}s）</div>
      </div>
    </div>
  </VanDialog>
</template>

<script>
export default {
  model: {
    prop: "show",
    event: "update:show",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    maxTime: {
      type: Number,
      default: 3,
    },
    title: {
      type: String,
      default: "提示",
    },
    isRouteToHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      count: 0,
      intervalId: null,
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.count = this.maxTime;
          this.countdown();
        } else {
          this.clearCountdown();
        }
      },
    },
  },
  destroyed() {
    this.clearCountdown();
  },
  methods: {
    getContainer() {
      return document.getElementById("app");
    },
    onConfirm() {
      if (this.isRouteToHome) {
        this.$HomeService.turnToHomeView();
      }
      this.onClose()
    },
    onClose() {
      this.$emit("update:show", false);
    },
    countdown() {
      this.clearCountdown();
      this.intervalId = setInterval(() => {
        this.count--;
        if (this.count <= 0) {
          this.clearCountdown();
          this.onConfirm();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hub-order-cancel {
  .title {
    font-weight: 700;
    padding: 12px;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    text-align: center;
  }

  .content {
    padding: 10px 15px 20px 15px;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
    box-sizing: border-box;
  }

  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    border-top: 1px solid #f2f2f2;
  }
  .btn {
    flex: 1;
    font-size: 16px;
    color: #1177ff;
    line-height: 50px;
    text-align: center;
  }
}
</style>
